import { render, staticRenderFns } from "./SettingItem.vue?vue&type=template&id=b999f6a4&scoped=true"
import script from "./SettingItem.vue?vue&type=script&lang=js"
export * from "./SettingItem.vue?vue&type=script&lang=js"
import style0 from "./SettingItem.vue?vue&type=style&index=0&id=b999f6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b999f6a4",
  null
  
)

export default component.exports